import KontaktForm from "../components/Kontakt/KontaktForm";
import KontaktInfo from "../components/Kontakt/KontaktInfo";
import Brands from "../components/LandingPage/Brands";
import Testimonials from "../components/LandingPage/Testimonials";
import PublicLayout from "../layout/PublicLayout";

export default function Kontakt() {
  return (
    <PublicLayout>
      <section className="bg-doctio-beige d-icon-background min-h-[200px] md:min-h-[320px] py-16">
        <div className="py-10 md:py-0 container mx-auto">
          <h1 className="text-left text-d2xl md:text-d4xl font-bold text-doctio-green">
            Kontakt os
          </h1>

          <div className="space-divider w-2 h-[24px]"></div>
        </div>
      </section>

      <section className="container grid md:grid-cols-2 gap-y-16 md:gap-y-0 mb-20 md:gap-x-20 mx-auto mt-[-60px] md:mt-[-160px]">
        <KontaktForm />
        <KontaktInfo />
      </section>
      <Testimonials />
      <Brands />
    </PublicLayout>
  );
}
